import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Checkbox,
  Box,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { sendEmail } from "../../../../store/actions/documentAction";
import EmailInputField from "../../../../components/EmailInputField";
import { isValidEmailList } from "../../../../utils/emailValidation";

export default function SendEmailModal({
  open,
  documents,
  onClose,
  onSuccess
}) {
  const [toEmails, setToEmails] = useState([]);
  const [ccEmails, setCcEmails] = useState([]);
  const [desc, setDesc] = useState("");
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && documents?.length) {
      setSelectedDocs(documents);
    }
  }, [open, documents]);

  const handleClose = () => {
    setToEmails([]);
    setCcEmails([]);
    setDesc("");
    setSelectedDocs([]);
    setLoading(false);
    onClose();
  };

  const toggleDoc = (doc) => {
    setSelectedDocs((prev) =>
      prev.some((d) => d.id === doc.id)
        ? prev.filter((d) => d.id !== doc.id)
        : [...prev, doc]
    );
  };

  const handleSend = async () => {
    try {
      if (!isValidEmailList(toEmails)) {
        alert("Invalid or missing To email(s).");
        return;
      }

      if (ccEmails.length && !isValidEmailList(ccEmails)) {
        alert("Invalid CC email(s): " + ccEmails.join(", "));
        return;
      }

      setLoading(true);
      const locNum = selectedDocs[0]?.locationNumber;
      const payload = {
        documents: selectedDocs?.map((d) => d.filePath),
        to: toEmails,
        cc: ccEmails,
        bodyText: desc,
        userId: 1
      };

      const res = await sendEmail(locNum, payload);
      onSuccess(res);
      handleClose();
    } catch (err) {
      console.error(err);
      alert("Failed to send email");
      setLoading(false);
    }
  };

  const allSelected =
    documents.length > 0 &&
    selectedDocs.length === documents.length;

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedDocs(documents);
    } else {
      setSelectedDocs([]);
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Send Email</DialogTitle>

      <DialogContent>
        {/* TO */}
        <Box mt={1}>
          <EmailInputField
            value={toEmails}
            onChange={setToEmails}
            multiple={true}
            label="To"
            placeholder="Type email and press Enter or comma"
            size="small"
          />
        </Box>

        {/* CC */}
        <Box mt={1}>
          <EmailInputField
            value={ccEmails}
            onChange={setCcEmails}
            multiple={true}
            label="Cc"
            placeholder="Type email and press Enter or comma"
            size="small"
          />
        </Box>

        {/* MESSAGE */}
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Message"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
          margin="dense"
        />

        {/* ATTACHMENTS */}
        <Typography variant="subtitle2" mt={2}>
          Attachments
        </Typography>

        {/* Select All */}
        <Box display="flex" alignItems="center">
          <Checkbox
            checked={allSelected}
            indeterminate={
              selectedDocs.length > 0 &&
              selectedDocs.length < documents.length
            }
            onChange={(e) => handleSelectAll(e.target.checked)}
          />
          <Typography fontSize={13} fontWeight={500}>
            Select All
          </Typography>
        </Box>

        <Box ml={2}>
          {documents.map((doc) => (
            <Box
              key={doc.id}
              display="flex"
              alignItems="center"
            >
              <Checkbox
                checked={selectedDocs.some((d) => d.id === doc.id)}
                onChange={() => toggleDoc(doc)}
              />
              <Typography fontSize={13}>
                {doc.control} - {doc.originalFileNameAlias}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSend}
          disabled={!toEmails.length || loading}
        >
          {loading ? "Sending..." : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
